/**
 * Rodzaje finansowania placówki
 *
 * @export
 * @enum {number}
 */
export enum SchoolFinancing {
  SUPPORTED = 1,
  SUBSIDIZED = 2,
  OTHER = 3
}

export const schoolFinancingTranslation = {
  [SchoolFinancing.SUPPORTED]: 'Prowadzone przez UM Lublin',
  [SchoolFinancing.SUBSIDIZED]: 'Nieprowadzone przez UM Lublin',
  [SchoolFinancing.OTHER]: 'Inne'
};

export const schoolFinancingList = [
  { text: schoolFinancingTranslation[SchoolFinancing.SUPPORTED], value: SchoolFinancing.SUPPORTED },
  { text: schoolFinancingTranslation[SchoolFinancing.SUBSIDIZED], value: SchoolFinancing.SUBSIDIZED }
];
